import { request } from './request';
import { getUserId, setSessionStartTime, getSessionStartTime } from './user.service';
import SessionManager from 'src/helpers/session-manager';

const extendSession = async () => {
  const userId = getUserId();

  const res = await request(
    'managesession',
    {
      fetchOptions: {
        method: 'POST',
        body: JSON.stringify({
          userId: userId,
          channelId: 'web',
          channelName: 'vodacom',
        }),
      },
    },
    null,
    null,
    false,
    true,
  );

  return res?.status === 200;
};

const ACTIVITY_THRESHOLD = 15 * 60000;
const WARNING_PADDING = 20000;
const INITIATE_EXTENSION_PADDING = 5000;
const KEEP_SESSION_ALIVE_INTERVAL = 3 * 60000; // every 3 minutes
const IS_SESSION_ALIVE_PADDING = 30 * 1000; // 30 seconds

const sessionManagerSingleton = new SessionManager(
  extendSession,
  setSessionStartTime,
  getSessionStartTime,
  ACTIVITY_THRESHOLD,
  WARNING_PADDING,
  INITIATE_EXTENSION_PADDING,
  KEEP_SESSION_ALIVE_INTERVAL,
  IS_SESSION_ALIVE_PADDING,
);

document.onmousedown = document.onmousemove = document.ontouchstart = document.onclick = document.onkeypress = () => {
  sessionManagerSingleton.setLastActivityTime();
};
document.addEventListener(
  'scroll',
  () => {
    sessionManagerSingleton.setLastActivityTime();
  },
  true,
);

export default sessionManagerSingleton;
